module.exports = __webpack_public_path__ + "static/media/sa.c54d71c7.svg";